// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2J0Oq","error":"Textarea_error__1wsb8","readonly":"Textarea_readonly__1UV3q","disabled":"Textarea_disabled__C43jH"};